import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import { forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes, useEffect } from 'react';
import { useFormContext as useReactHookFormContext } from 'react-hook-form';
import { useSiloRealFormContext } from '../base/use-form-context';
import { useFormFieldStyles } from './use-form-field-styles';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;

type Props = {
  tid: string;
  name: string;
  required?: boolean;
  label?: string;
  size?: 'medium' | 'large';
  onChange?: (checked: boolean) => void;
};

export const checkbox: FR<HTMLInputElement, Props> = forwardRef((props, ref) => {
  const { name = 'checkbox', label = 'Seleccionar', required = false } = props;
  const { size, onChange } = props;

  const { verify } = useSiloRealFormContext();
  useEffect(() => verify.uniqueness(name), []);

  const {
    register,
    formState: { errors },
  } = useReactHookFormContext();

  const hasError = Boolean(errors[name]);
  const errorMessage = errors[name]?.message as string | undefined;
  const fieldSx = useFormFieldStyles({ size });

  return (
    <FormControl sx={fieldSx} error={hasError} required={required}>
      <FormControlLabel
        label={label}
        control={
          <Checkbox
            inputRef={ref}
            data-testid={props.tid}
            size="small"
            {...register(name, {
              required,
              onChange: (e) => {
                onChange?.(e.target.checked);
              },
            })}
          />
        }
      />
      <FormHelperText>{errorMessage}</FormHelperText>
    </FormControl>
  );
});

checkbox.displayName = 'SiloReal-Form-Field-Checkbox';
